import Image from "next/image";

import { cn } from "@/lib/utils";

import bgDesktop from "@/public/optIn/final-cta-bg-desktop.jpg";
import bgMobile from "@/public/optIn/final-cta-bg-mobile.jpg";

// Arches render shared by the Opt-In final CTA and the Opt-In Thank You page.
// Ships as two exported assets: the desktop plate is the full 1920×875 render
// (positioned by the caller, fading to black at both ends through `wash`); the
// mobile plate is the design's 430×339 crop that flows inside the page.
export const ARCHES_MOBILE_WASH =
  "linear-gradient(180deg, rgba(0,0,0,0) 66.4%, #000 99.9%), linear-gradient(180deg, #000 1.3%, rgba(0,0,0,0.87) 6.2%, rgba(0,0,0,0) 22%)";

export function ArchesDesktop({ className, wash }: { className?: string; wash: string }) {
  return (
    // Sized in rem like everything else so the arches keep the design's
    // geometry against the copy; the near-black edges fade into the page when
    // the viewport is wider than the 240rem frame.
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute left-1/2 hidden h-[109.375rem] w-[240rem] -translate-x-1/2 lg:block",
        className,
      )}>
      <Image
        src={bgDesktop}
        alt=""
        fill
        sizes="1920px"
        className="object-cover"
      />
      <div
        className="absolute inset-0"
        style={{ backgroundImage: wash }}
      />
      <div className="absolute inset-y-0 left-0 w-[24rem] bg-gradient-to-r from-black to-transparent" />
      <div className="absolute inset-y-0 right-0 w-[24rem] bg-gradient-to-l from-black to-transparent" />
    </div>
  );
}

export function ArchesMobile({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn("pointer-events-none relative aspect-[430/339] w-full lg:hidden", className)}>
      <Image
        src={bgMobile}
        alt=""
        fill
        sizes="100vw"
        className="object-cover"
      />
      <div
        className="absolute inset-0"
        style={{ backgroundImage: ARCHES_MOBILE_WASH }}
      />
    </div>
  );
}
